import Swiper from "swiper";
import {Pagination, Navigation} from "swiper/modules";

export class PopUpSlider {
    constructor(content, options) {
        this.content = content;
        this.options = options;
        this.isOpen = false;
        this.overlay = null;
        this.uniqueId = Math.random().toString(36).substr(2, 9);
    }

    open() {
        this.slider.classList.add('mksun-pop-up-slider--open');
        this.overlay.classList.add('mksun-pop-up-slider__overlay--open');
        this.isOpen = true;
    }

    close() {
        this.slider.classList.remove('mksun-pop-up-slider--open');
        this.overlay.classList.remove('mksun-pop-up-slider__overlay--open');
        this.isOpen = false;
    }

    openSlide(index) {
        this.swiper.slideTo(index);
        this.open();
    }





    createSlider() {
        this.slider = document.createElement('div');
        this.slider.classList.add('mksun-pop-up-slider');
        this.slider.classList.add(`mksun-pop-up-slider--${this.uniqueId}`);


        this.swiperCtn = document.createElement('div');
        this.swiperCtn.classList.add('swiper');
        this.slider.appendChild(this.swiperCtn);

        this.controlsCtn = document.createElement('div');
        this.controlsCtn.classList.add('mksun-pop-up-slider__controls');


        this.btnPrev = document.createElement('div');
        this.btnPrev.classList.add('mksun-pop-up-slider__controls__btn-prev');
        this.btnPrev.innerHTML = '<span class="material-symbols-outlined">chevron_left</span>';
        this.controlsCtn.appendChild(this.btnPrev);

        this.pagination = document.createElement('div');
        this.pagination.classList.add('mksun-pop-up-slider__controls__pagination');
        this.pagination.classList.add('swiper-pagination');
        this.controlsCtn.appendChild(this.pagination);

        this.btnNext = document.createElement('div');
        this.btnNext.classList.add('mksun-pop-up-slider__controls__btn-next');
        this.btnNext.innerHTML = '<span class="material-symbols-outlined">chevron_right</span>';
        this.controlsCtn.appendChild(this.btnNext);

        this.btnClose = document.createElement('div');
        this.btnClose.classList.add('mksun-pop-up-slider__btn-close');
        this.btnClose.innerHTML = '<span class="material-symbols-outlined">close</span>';
        this.btnClose.addEventListener('click', () => {
            this.close();
        });





        const slidesCtn = document.createElement('div');
        slidesCtn.classList.add('mksun-pop-up-slider__slides');
        slidesCtn.classList.add('swiper-wrapper');

        this.slides = this.content.map((slide, index) => {
            const slideEl = document.createElement('div');
            slideEl.classList.add('mksun-pop-up-slider__slides__slide');
            slideEl.classList.add('swiper-slide');

            const slideImage = document.createElement('img');
            slideImage.classList.add('mksun-pop-up-slider__slides__slide__image');
            slideImage.src = slide.image.src;
            slideImage.alt = slide.image.alt;
            slideEl.appendChild(slideImage);

            const slideContent = document.createElement('div');
            slideContent.classList.add('mksun-pop-up-slider__slides__slide__content');
            slideContent.innerHTML = slide.content;
            slideEl.appendChild(slideContent);

            slidesCtn.appendChild(slideEl);

            return slideEl;
        });

        this.swiperCtn.appendChild(this.btnClose);

        this.swiperCtn.appendChild(slidesCtn);

        this.swiperCtn.appendChild(this.controlsCtn);

        this.overlay = document.createElement('div');
        this.overlay.classList.add('mksun-pop-up-slider__overlay');
        this.overlay.addEventListener('click', () => {
            this.close();
        });


        document.body.appendChild(this.slider);
        document.body.appendChild(this.overlay);


        this.swiper = new Swiper(`.mksun-pop-up-slider--${this.uniqueId} .swiper`, {
            modules: [Navigation, Pagination],
            navigation: {
                nextEl: '.mksun-pop-up-slider__controls__btn-next',
                prevEl: '.mksun-pop-up-slider__controls__btn-prev',
            },
            pagination: {
                el: '.mksun-pop-up-slider__controls__pagination',
                clickable: true,
            },
            centeredSlides: true,
            slidesPerView: 'auto',
            spaceBetween: 0,
        })
    }

}